// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_array from "../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as PartnerScoreConfig from "../store/PartnerScoreConfig.bs.js";
import * as PartnerScoreHelper from "./PartnerScoreHelper.bs.js";

function calculateScorePosition(current_score, max_score) {
  var score_position = current_score < max_score ? 100 / max_score * current_score : 100;
  return String(score_position) + "%";
}

function getSliderTrackBackgroundColor(current_score, max_score, index) {
  if (current_score >= max_score) {
    return PartnerScoreConfig.inactive_span_color;
  } else if (index !== 0) {
    if (index !== 1) {
      return "linear-gradient(90deg, " + Caml_array.get(PartnerScoreConfig.span_color, index - 1 | 0) + ", " + Caml_array.get(PartnerScoreConfig.span_color, index) + " 50%)";
    } else {
      return "linear-gradient(90deg, " + Caml_array.get(PartnerScoreConfig.span_color, index - 1 | 0) + ", " + Caml_array.get(PartnerScoreConfig.span_color, index) + " 20%)";
    }
  } else {
    return "";
  }
}

function getSliderSpanLength(max_score, current_score, prev_score) {
  var span_length = 100 / max_score * (current_score - prev_score);
  return String(span_length) + "%";
}

function getSliderThumbPosition(current_score, max_score) {
  var score_position = calculateScorePosition(current_score, max_score);
  if (score_position === "100%") {
    return "calc(100% - 28px)";
  } else {
    return "calc(" + score_position + " - 20px)";
  }
}

function getSliderBoxPosition(current_score, max_score) {
  var score_position = calculateScorePosition(current_score, max_score);
  switch (score_position) {
    case "0%" :
        return "0%";
    case "100%" :
        return "calc(100% - 49px)";
    default:
      return "calc(" + score_position + " - 14.5px)";
  }
}

function getSliderBoxStyle(current_score, isSuspended) {
  var match = current_score !== 0 && isSuspended ? [
      Caml_array.get(PartnerScoreConfig.active_slider_box_style, 0),
      Caml_array.get(PartnerScoreConfig.active_slider_box_style, 1)
    ] : [
      Caml_array.get(PartnerScoreConfig.inactive_slider_box_style, 0),
      Caml_array.get(PartnerScoreConfig.inactive_slider_box_style, 1)
    ];
  return [
          match[0],
          match[1]
        ];
}

function getSliderPinPosition(current_score, max_score) {
  var score_position = calculateScorePosition(current_score, max_score);
  switch (score_position) {
    case "0%" :
        return "calc(0% + 10px)";
    case "100%" :
        return "calc(100% - 9px)";
    default:
      return "calc(" + score_position + " + 6px)";
  }
}

function getMessageBoxTooltipPosition(action_threshold, max_score) {
  var score_position = calculateScorePosition(action_threshold, max_score);
  switch (score_position) {
    case "0%" :
        return "calc(0% - 6px)";
    case "100%" :
        return "calc(100% - 16px)";
    default:
      return "calc(" + score_position + " - 3px)";
  }
}

function getSliderPinHeight(value_box_height, slider_container_height, slider_track_height, current_score, max_score, action_threshold) {
  var match = current_score === PartnerScoreHelper.thresholdValueToFloat(action_threshold) || current_score >= max_score;
  if (value_box_height !== 0 && slider_container_height !== 0 && slider_track_height !== 0) {
    if (match) {
      return "calc(" + String((slider_container_height - slider_track_height | 0) - value_box_height | 0) + "px - 10px)";
    } else {
      return "calc(" + String((slider_container_height - slider_track_height | 0) - value_box_height | 0) + "px + 23px)";
    }
  } else {
    return "0";
  }
}

function getTooltipStyle(isSuspended, action_threshold, max_score) {
  if (isSuspended) {
    return {
            color: PartnerScoreConfig.suspended_tooltip_color,
            left: getMessageBoxTooltipPosition(action_threshold, max_score)
          };
  } else {
    return {
            color: PartnerScoreConfig.unsuspended_tooltip_color
          };
  }
}

function getMilestonePosition(index, length) {
  if (index !== 0) {
    if (index === (length - 1 | 0)) {
      return "-8px";
    } else {
      return "0";
    }
  } else {
    return "2px";
  }
}

function getMilestoneIconPosition(index, length) {
  if (index !== 0) {
    if (index === (length - 1 | 0)) {
      return "0";
    } else {
      return "8px";
    }
  } else {
    return "11px";
  }
}

function getMarkingPosition(index, length) {
  if (index === (length - 1 | 0)) {
    return "0";
  } else {
    return "1.5ch";
  }
}

function getMilestoneBackgroundColor(current_score, max_score, index, track_thresholds, isSuspended) {
  if (current_score >= max_score) {
    if (index === (track_thresholds.length - 1 | 0)) {
      return PartnerScoreConfig.danger_milestone_color;
    } else {
      return PartnerScoreConfig.inactive_milestone_color;
    }
  } else if (index !== 0) {
    if (index === (track_thresholds.length - 1 | 0)) {
      return PartnerScoreConfig.danger_milestone_color;
    } else if (PartnerScoreHelper.thresholdValueToFloat(Caml_array.get(track_thresholds, index)) <= current_score && current_score < PartnerScoreHelper.thresholdValueToFloat(Caml_array.get(track_thresholds, index + 1 | 0))) {
      if (isSuspended) {
        return Caml_array.get(PartnerScoreConfig.span_color, index);
      } else {
        return PartnerScoreConfig.inactive_milestone_color;
      }
    } else if (PartnerScoreHelper.thresholdValueToFloat(Caml_array.get(track_thresholds, index)) < current_score && current_score > PartnerScoreHelper.thresholdValueToFloat(Caml_array.get(track_thresholds, index + 1 | 0))) {
      return PartnerScoreConfig.inactive_milestone_color;
    } else {
      PartnerScoreHelper.thresholdValueToFloat(Caml_array.get(track_thresholds, index)) > current_score;
      return Caml_array.get(PartnerScoreConfig.span_color, index);
    }
  } else {
    return PartnerScoreConfig.safe_milestone_color;
  }
}

function getMilestoneAnimationName(action_threshold, index, track_thresholds, isSuspended) {
  var match = Caml_array.get(track_thresholds, index);
  if (isSuspended && match === action_threshold) {
    return "animate-milestone";
  } else {
    return "";
  }
}

function getMilestoneIconAnimationName(action_threshold, index, track_thresholds, isSuspended) {
  var match = Caml_array.get(track_thresholds, index);
  if (isSuspended && match === action_threshold) {
    return "animate-milestone-icon";
  } else {
    return "";
  }
}

export {
  calculateScorePosition ,
  getSliderTrackBackgroundColor ,
  getSliderSpanLength ,
  getSliderThumbPosition ,
  getSliderBoxPosition ,
  getSliderBoxStyle ,
  getSliderPinPosition ,
  getMessageBoxTooltipPosition ,
  getSliderPinHeight ,
  getTooltipStyle ,
  getMilestonePosition ,
  getMilestoneIconPosition ,
  getMarkingPosition ,
  getMilestoneBackgroundColor ,
  getMilestoneAnimationName ,
  getMilestoneIconAnimationName ,
  
}
/* PartnerScoreHelper Not a pure module */
